import { useConfigService } from '@thd-nucleus/experience-context';
export var getPreYearData = function (unclaimedPreYearPerks) {
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < unclaimedPreYearPerks.length; i++) {
        // eslint-disable-next-line no-param-reassign
        unclaimedPreYearPerks[i].tierPerks = [unclaimedPreYearPerks[i]];
    }
    return unclaimedPreYearPerks;
};
var today = new Date();
var padWithZero = function (number) {
    return number < 10 ? "0".concat(number) : number.toString();
};
export var formattedToday = "".concat(padWithZero(today.getMonth() + 1), "/").concat(padWithZero(today.getDate()), "/").concat(today.getFullYear());
export var useDisplayAmount = function () {
    var enablePerkAmountRemoval = ['1', 1].includes(useConfigService('ENABLE_PERK_AMOUNT_REMOVAL'));
    var getDisplayAmount = function (perk, optionPerk) {
        var _a, _b;
        if (!perk && !optionPerk)
            return '';
        var dollarAmount = perk.amount === null ? '' : "$".concat(perk.amount, "\u00A0");
        var reward = (_a = optionPerk !== null && optionPerk !== void 0 ? optionPerk : perk) !== null && _a !== void 0 ? _a : (_b = perk.options) === null || _b === void 0 ? void 0 : _b[1];
        var activationType = reward === null || reward === void 0 ? void 0 : reward.activationType;
        var offerType = reward === null || reward === void 0 ? void 0 : reward.offerType;
        var hideAmount = activationType === 'CMS' ||
            (activationType === 'PRICING_ENGINE' && offerType === 'OFFER');
        var CMSLogicDisplayAmount = hideAmount ? '' : dollarAmount;
        // feature switch return
        var amountDisplay = enablePerkAmountRemoval
            ? dollarAmount
            : CMSLogicDisplayAmount;
        return amountDisplay;
    };
    return getDisplayAmount;
};
